import { request } from "utils/request";
import { AxiosPromise } from "axios";


export const shopRateApi = {
    findAll: (params?: any): AxiosPromise<any> => request({
        url: '/v1/admin/rate',
        params
    }),
    create: (data: any): AxiosPromise<any> => request({
        url: '/v1/admin/rate',
        data,
        method: 'post'
    }),
    update: (id: number, data: any): AxiosPromise<any> => request({
        url: `/v1/admin/rate/${id}`,
        method: 'patch',
        data
    }),
    delete: (id: number): AxiosPromise<any> => request({
        url: `/v1/admin/rate/${id}`,
        method: 'delete'
    }),
}
